import React, { useState } from "react"
import "./filter.css"
import Button from "react-bootstrap/Button"
import Modal from "react-bootstrap/Modal"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTimes } from "@fortawesome/free-solid-svg-icons"

function CheckboxesFilter({ searchBy, clearFilter, list, filterName }) {
  const [checkedItemList, setCheckedItemList] = useState([])

  const checkboxChange = (itemChecked) => {
    console.log("clicked")
    setCheckedItemList((prevState) => {
      if (prevState.includes(itemChecked)) {
        return prevState.filter((item) => {
          return item !== itemChecked
        })
      } else {
        return [...prevState, itemChecked]
      }
    })
    console.log("checked list ", checkedItemList)
  }

  //bootstrap modal
  const [show, setShow] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <div className='filter-container'>
      <Button className='myBtn' onClick={handleShow}>
        Filter by {filterName}
      </Button>

      <Button
        className='myBtn clear-btn'
        onClick={() => {
          clearFilter(filterName)
          setCheckedItemList([])
        }}>
        <FontAwesomeIcon icon={faTimes} />
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Filter by {filterName}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul className='checkboxesList'>
            {list.map((item) => {
              return (
                <div className='checkboxContainer' key={item}>
                  <input
                    type='checkbox'
                    id={item}
                    name={item}
                    value={item}
                    onChange={() => {}}
                    checked={checkedItemList.includes(item)}></input>
                  <label
                    className='checkboxLabel'
                    onClick={() => {
                      checkboxChange(item)
                    }}>
                    <span></span>
                    {item}
                  </label>
                </div>
              )
            })}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className='myBtn'
            onClick={() => {
              searchBy(filterName, `${checkedItemList.join(",")}`)
              handleClose()
            }}>
            Filter
          </Button>
          <Button className='myBtn' onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default CheckboxesFilter
